module.exports = __webpack_public_path__ + "static/img/5.502de3ee.png";